import axios from 'axios';


const API_BASE_URL = process.env.API_BASE_URL;
const API_SESSION_TIMEOUT = Number(process.env.API_SESSION_TIMEOUT);

const session = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_SESSION_TIMEOUT, // in milliseconds
});

export default session;



// WEBPACK FOOTER //
// ./src/api/session.js